module.exports = __webpack_public_path__ + "arrow_blue_right.a441f213.svg";